import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import { Toaster } from "./components/ui/sonner";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Leads from "./pages/Leads";
import LeadDetail from "./pages/LeadDetail";
import Import from "./pages/Import";
import CalendarPage from "./pages/Calendar";
import Companies from "./pages/Companies";
import CompanyDetail from "./pages/CompanyDetail";
import EmailSettings from "./pages/EmailSettings";
import EmailSearch from "./pages/EmailSearch";
import Opportunities from "./pages/Opportunities";
import Pipeline from "./pages/Pipeline";
import Feasibilities from "./pages/Feasibilities";

// Layout
import AppLayout from "./components/layout/AppLayout";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth context
export const useAuth = () => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("stryde_user");
    return saved ? JSON.parse(saved) : null;
  });

  const login = (userData) => {
    localStorage.setItem("stryde_user", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("stryde_user");
    setUser(null);
  };

  return { user, login, logout };
};

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const saved = localStorage.getItem("stryde_user");
  if (!saved) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/leads" element={<Leads />} />
                    <Route path="/leads/:id" element={<LeadDetail />} />
                    <Route path="/companies" element={<Companies />} />
                    <Route path="/companies/:name" element={<CompanyDetail />} />
                    <Route path="/calendar" element={<CalendarPage />} />
                    <Route path="/opportunities" element={<Opportunities />} />
                    <Route path="/pipeline" element={<Pipeline />} />
                    <Route path="/feasibilities" element={<Feasibilities />} />
                    <Route path="/import" element={<Import />} />
                    <Route path="/email" element={<EmailSettings />} />
                    <Route path="/email-search" element={<EmailSearch />} />
                  </Routes>
                </AppLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
